import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { directories } from '../data/directories';
import { DirectoryType } from '../types/content';
import { getSourceById } from '../utils/sourceIndex';
import { PageHeader } from '../components/PageHeader';
import { SourceRef } from '../components/SourceRef';
import { DataBadge } from '../components/DataBadge';
import { COMPILED_LABEL } from '../data/sources';
const TYPE_STYLE: Record<DirectoryType, string> = {
  Registry: 'border-human/40 text-human',
  Marketplace: 'border-machine/40 text-machine',
  'On-chain': 'border-live/40 text-live',
  Scanner: 'border-signal/50 text-signal',
  Aggregator: 'border-line text-muted'
};
export function Directories() {
  return <>
      <PageHeader title="Directories" lede="Every surface this census reads from — registries, marketplaces, on-chain explorers, scanners and aggregators. Ordered by the size of what they hold." data-id="element-600" data-mp="28vb6pfyg2x71">
        <DataBadge mode="snapshot" source="Curated directory counts" asOf={COMPILED_LABEL} data-id="element-601" data-mp="ejwemshyolo4" />
      </PageHeader>
      <section className="mx-auto max-w-[1400px] px-5 pt-10 md:px-8" data-id="element-602" data-mp="158juq0ouh27u">
        <ul className="grid gap-px overflow-hidden rounded-lg border border-line bg-line sm:grid-cols-2 lg:grid-cols-3" data-id="element-603" data-mp="1578qjzrhlsg7">
          {directories.map(d => {
          const src = getSourceById(d.sourceId);
          return <li key={d.name} className="flex flex-col bg-bg p-6" data-id="element-604" data-mp="1sxw00ph1wq4v">
                <div className="flex items-start justify-between gap-3" data-id="element-605" data-mp="1sw1p83zhueei">
                  <h2 className="text-[15px] font-medium text-ink" data-id="element-606" data-mp="1o0clrpkcsdcx">{d.name}</h2>
                  <span className={`shrink-0 rounded border px-1.5 py-0.5 font-mono text-[10.5px] ${TYPE_STYLE[d.type]}`} data-id="element-607" data-mp="1iz6rvoeyik1t">{d.type}</span>
                </div>
                <p className={`mt-6 font-mono text-[2.4rem] leading-none tabular ${d.scale === 'Unpublished' ? 'text-faint' : 'text-ink'}`} data-id="element-608" data-mp="1f0ph8uwburfn">
                  {d.scale}
                  <SourceRef id={d.sourceId} estimate={d.range} data-id="element-609" data-mp="3hmvf59mc1c5" />
                </p>
                <p className="mt-2 font-mono text-[12px] text-muted" data-id="element-610" data-mp="51ohcy377wve">{d.unit}</p>
                <p className="mt-4 text-[13.5px] leading-relaxed text-ink/80" data-id="element-611" data-mp="9zq17l8g807x">{d.description}</p>
                {src && !src.url.startsWith('/') && <a href={src.url} target="_blank" rel="noopener noreferrer" className="mt-auto inline-flex items-center gap-1 pt-5 font-mono text-[11.5px] text-muted hover:text-machine" data-id="element-612" data-mp="3r9o529ipg4zr">
                    {src.publisher}
                    <ArrowUpRightIcon className="h-3 w-3" data-id="element-613" data-mp="3n5q3zt9tkk42" />
                  </a>}
              </li>;
        })}
        </ul>
      </section>
    </>;
}